import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserCashBackDeal from './user-cash-back-deal';
import UserCashBackDealDetail from './user-cash-back-deal-detail';
import UserCashBackDealUpdate from './user-cash-back-deal-update';
import UserCashBackDealDeleteDialog from './user-cash-back-deal-delete-dialog';

const UserCashBackDealRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserCashBackDeal />} />
    <Route path="new" element={<UserCashBackDealUpdate />} />
    <Route path=":id">
      <Route index element={<UserCashBackDealDetail />} />
      <Route path="edit" element={<UserCashBackDealUpdate />} />
      <Route path="delete" element={<UserCashBackDealDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserCashBackDealRoutes;
